import React, { useContext } from 'react';
import { Rating, Row } from '@thd-olt-component-react/core-ui';
import className from 'classnames';
import { ProductPodContext } from '../../ProductPodContext';
import { getCustomUrlWithAnalytics } from '../../utils';
import './product-rating.style.scss';

export const ProductRating = () => {
  const {
    onRatingClick,
    product: {
      identifiers,
      reviews,
      info,
    } = {},
    target,
    hosts,
    channel,
    podType,
    hideRating
  } = useContext(ProductPodContext);

  if (hideRating) return null;

  const {
    globalCustomConfigurator,
    isBrioSku,
  } = info || {};

  const {
    canonicalUrl,
    productType
  } = identifiers || {};

  const {
    ratingsReviews
  } = reviews || {};

  const customExperience = globalCustomConfigurator?.customExperience;
  const productURL = getCustomUrlWithAnalytics({
    customExperience,
    productType,
    blindsHost: hosts?.customBlinds,
    canonicalUrl,
    info
  });

  const emptyRatingsWhichFlexesTheContainer = () => {
    return (
      <div className="product-pod__ratings-empty" />
    );
  };

  const hideRatings = ratingsReviews?.totalReviews < 1;
  if (podType === 'sidebyside' && (hideRatings || !ratingsReviews)) return emptyRatingsWhichFlexesTheContainer();
  if (hideRatings || !ratingsReviews) return null;

  const isMobile = channel === 'mobile';
  const ratingsClasses = className(
    'productPod__flex',
    'product-pod__ratings', {
      'productPod__flex--spacer': isMobile
    }
  );
  const ratingWrapperClasses = className('product-pod__ratings-link', {
    'product-pod__ratings-link--brio-mobile': isBrioSku && isMobile
  });

  return (
    <>
      <a
        className={ratingWrapperClasses}
        href={`${productURL}#ratings-and-reviews`}
        onClick={onRatingClick}
        target={target}
        data-testid="product-pod__ratings-link"
      >
        <Row className={ratingsClasses}>
          <Rating value={parseFloat(ratingsReviews.averageRating)} />
          <span className="product-pod__ratings-count">{`(${ratingsReviews.totalReviews})`}</span>
        </Row>
      </a>
    </>
  );
};

ProductRating.displayName = 'ProductRating';
